// extracted by mini-css-extract-plugin
export default {"loading":"styles-module__loading__src-labstep-web-core-Print-_iWlkt","print":"styles-module__print__src-labstep-web-core-Print-_jZpZ5"};